import { AxiosInstance } from 'axios';
import Qs from 'query-string';
import { ContentContextInfo, ContentItem, PublishChannel } from '../constants';

interface ParamsProps {
  publish_status: string;
  publish_channel: string;
  // _match?: string;
  _page?: number;
  _num?: number;
}

export const DAKA_ID_1 = 'zhecaishiyuanyuzhou';
export const DAKA_TIME_1 = 1663592400000;

// eslint-disable-next-line react-func/max-lines-per-function
export const getContentServices = ({ OfficialGateWayInstance }: { OfficialGateWayInstance: AxiosInstance }) => ({
  // eslint-disable-next-line react-func/max-lines-per-function
  getContentList(params: ParamsProps) {
    if (params.publish_channel === PublishChannel.MOGUL_SHARING) {
      return Promise.resolve({
        data: {
          hasMore: false,
          items: [
            {
              brief_intro:
                '2010年12月15日，杭州落下这年冬天的第一场大雪。虽距2011年元旦还有十多天，这漫天飞雪还是让人们提前感受到了节日的气息。与此同时，还在限号测试的在线游戏《倩女幽魂》中的数字杭州也在一夜之间银装素裹。虚拟世界和真实世界的惊人同步，似乎打破了次元边界，让玩家们兴奋不已。',
              content_type: 'rtf',
              cover: 'https://static.fuxi.netease.com/yaotai/portal/20220923/l8duvpsz_633251.png',
              display_time: DAKA_TIME_1,
              id: DAKA_ID_1,
              publish_channel: PublishChannel.MOGUL_SHARING,
              tags: ['元宇宙'],
              title: '这才是你该了解的元宇宙',
              update_time: DAKA_TIME_1,
            },
          ],
          total: 1,
        },
      } as any as { items: ContentItem[]; has_more: boolean; total: number });
    }
    return OfficialGateWayInstance.get<{ items: ContentItem[]; has_more: boolean; total: number }>(
      `/web/contents?${Qs.stringify(params)}`,
    );
  },
  getHelpList(params: ParamsProps) {
    return OfficialGateWayInstance.get<{ items: ContentItem[]; has_more: boolean; total: number }>(
      `/web/contents?${Qs.stringify(params)}`,
    );
  },
  getContentInfo(id?: string) {
    return OfficialGateWayInstance.get<ContentItem>(`/web/contents/${id}`);
  },
  getContextInfo(id?: string, channel?: string) {
    return OfficialGateWayInstance.get<ContentContextInfo>(
      `/web/contents/context/${id}?${Qs.stringify({ publish_channel: channel })}`,
    );
  },
});
